import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tabs } from "antd";
import ManufacturingEntry from "./Manufacturing Entry/ManufacturingEntry";
import ManufacturingRecord from "./ManufacturingRecord";
import ManufacturingVoucher from "./ManufacturingVoucher/ManufacturingVoucher";
import BOM from "./BOM/BOM";
import { accessChecker, pathSpliter } from "../../lib/functions";
import { useLocation, useNavigate } from "react-router-dom";
import { selectAuthInfo } from "../Auth/authSelectors";


const Manufacturing = () => {
  const location = useLocation();
  const mfId = pathSpliter(location.pathname, 2)
      ? pathSpliter(location.pathname, 2)
      : null;
  const navigate = useNavigate();
  const authInfo = useSelector(selectAuthInfo);
  const isPerfumeIndustry = authInfo?.branch_company_type === "Perfume Industry";

  const params = new URLSearchParams(location.search);
const activeTab = params.get("tab") || "entry";

  const menuData = [
    {
      key: "entry",
      value: "production_entry",
      label: "Manufacturing Journal Entry",
      children: (
        <>
          <ManufacturingEntry />
        </>
      ),
    },
    {
      key: "record",
      value: "production_record",
      label: "Manufacturing Record",
      children: (
        <>
          <ManufacturingRecord />
        </>
      ),
    },
    {
      key: "voucher",
      value: "production_voucher",
      label: "Manufacturing Voucher",
      children: (
        <>
          <ManufacturingVoucher />
        </>
      ),
    },
    ...(isPerfumeIndustry
      ? [
          {
            key: "bom",
            value: "production_entry",
            label: "Bill of Materials",
            children: (
              <>
                <BOM />
              </>
            ),
          },
        ]
      : []),
  ];

  const filteredMenuData = menuData.filter((menuItem) => accessChecker(menuItem.value));
  return (
    <Tabs
      activeKey={activeTab}
      onChange={(key) => {
        // ✅ Keep mfId ONLY when staying in entry tab
        if (key === "entry" && mfId) {
          navigate(`/manufacturing/${mfId}?tab=entry`);
        } else {
          // ✅ Drop mfId when leaving entry
          navigate(`/manufacturing?tab=${key}`);
        }
      }}
      type="card"
      size="medium"
      style={{ marginBottom: 32 }}
      items={filteredMenuData}
    />
  );
};

export default Manufacturing;
